import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";

export default class LineResult extends SymbolWinResult {
    /**
     * NOT 0 indexed. Starts from 1
     */
    public line: number;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/results/line-result.ts